var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4482 11.6039C27.4452 13.1746 28.0091 14.698 29.0445 15.9162C30.0798 17.1344 31.523 17.9725 33.1296 18.2887C33.2268 18.8258 33.2775 19.3695 33.2814 19.9145L27.4482 11.6039ZM27.4482 11.6039V11.0317C26.4579 10.5651 25.3939 10.2582 24.2992 10.1235L27.4482 11.6039ZM23.2541 42.8306L23.2664 42.8303C24.8736 42.7948 26.4245 42.2142 27.6432 41.1791C28.8633 40.1428 29.6737 38.715 29.9148 37.1422L30.126 35.765H37.2651H38.7651V34.265V31.7037V31.0074L38.2332 30.558L37.9162 30.2901C37.9153 30.2894 37.9144 30.2886 37.9135 30.2879C37.1217 29.612 36.428 28.8409 35.849 27.9954C35.2498 26.8518 34.888 25.6109 34.7814 24.3408V19.9145H34.7814L34.7814 19.9039C34.7769 19.2728 34.7181 18.6432 34.6057 18.0217L34.4235 17.0146L33.4193 16.817C32.1368 16.5645 30.9974 15.8978 30.1875 14.9447C29.3787 13.9932 28.9459 12.8136 28.9482 11.6068V11.6039V11.0317V10.0804L28.0876 9.67485C27.3541 9.3292 26.5862 9.06036 25.797 8.87181C25.7689 8.17117 25.4658 7.51712 24.9657 7.03829C24.4425 6.53722 23.7461 6.26654 23.0329 6.26654C22.3198 6.26654 21.6234 6.53722 21.1001 7.03829C20.5862 7.53043 20.2803 8.20767 20.2671 8.93034C17.9826 9.49694 15.9106 10.7172 14.3388 12.4538C12.4727 14.5154 11.4393 17.1654 11.4457 19.9163V24.3408C11.339 25.6126 10.9764 26.8551 10.3758 27.9999C9.8073 28.8433 9.12538 29.6142 8.34623 30.2924L8.03191 30.558L7.5 31.0074V31.7037V34.265V35.765H9H16.1387L16.3501 37.1424C16.5981 38.7581 17.4465 40.2189 18.7196 41.2599C19.9914 42.2998 21.603 42.8535 23.2541 42.8306ZM35 16.5C38.0376 16.5 40.5 14.0376 40.5 11C40.5 7.96244 38.0376 5.5 35 5.5C31.9624 5.5 29.5 7.96244 29.5 11C29.5 14.0376 31.9624 16.5 35 16.5Z",
    fill: "url(#paint0_linear_1502_123)",
    stroke: "#127081",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1502_123",
    x1: 32.9512,
    y1: 7,
    x2: 37.9268,
    y2: 15.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/bell-active.bb7414b25c7611ac467e5147d8868530.svg";
export { ForwardRef as ReactComponent };